/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LTR
 */
export interface LTR {
    /**
     * 
     */
    unit?: string;
    /**
     * 
     */
    remaining?: number;
    /**
     * 
     */
    total?: number;
}

/**
 * Check if a given object implements the LTR interface.
 */
export function instanceOfLTR(value: object): value is LTR {
    return true;
}

export function LTRFromJSON(json: any): LTR {
    return LTRFromJSONTyped(json, false);
}

export function LTRFromJSONTyped(json: any, ignoreDiscriminator: boolean): LTR {
    if (json == null) {
        return json;
    }
    return {
        
        'unit': json['unit'] == null ? undefined : json['unit'],
        'remaining': json['remaining'] == null ? undefined : json['remaining'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function LTRToJSON(json: any): LTR {
    return LTRToJSONTyped(json, false);
}

export function LTRToJSONTyped(value?: LTR | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'unit': value['unit'],
        'remaining': value['remaining'],
        'total': value['total'],
    };
}

